<script>
    import { createEventDispatcher } from 'svelte'
    import { Link, navigateTo } from 'yrv'
    import ActionButton from '../../components/ActionButton/ActionButton.svelte'
    // import TouchIcon from '../../components/TouchIcon/TouchIcon.svelte'
    import ListItem from '../../components/ListItem/ListItem.svelte'
    import Dialog from '../../components/Modal/Dialog.svelte'
    import TagItem from '../../components/Tags/TagItem.svelte'
    import moment from 'moment'
    

    export let data
    export let users
    export let currentUserId

    const dispatch = createEventDispatcher ();

    let deleteDialog = false,
        notifyBusy = false

    const openClient = (event) => {
        // console.log ('openClient', data)
        dispatch ('client', {
            bean: data
        })
    }

    const sendNotification = (event) => {
        notifyBusy = true;
        setTimeout (() => { notifyBusy = false }, 1000)
        dispatch ('notify', {
            bean: data
        })
    }

    const deleteItem = (event) => {
        deleteDialog = true
    }

    const cloneItem = (event) => {
        dispatch ('clone', {
            bean: data
        })
    }

    const editItem = (event) => {
        dispatch ('edit', {
            bean: data
        })
    }

    const cancelDelete = () => {
        deleteDialog = false
    }

    const confirmDelete = () => {
        deleteDialog = false;
        dispatch ('delete', {
            bean: data
        })
    }
</script>

<style>
    .ProgramItem.otherowner :global(.ListItem) {
        background-color: #f4f4e5;
    }
    .ProgramItem .status {
        float: left;
        width: 50px;
        text-align: center;
        padding-top: 8px;
    }
    .ProgramItem .status .resolved-icn {
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 50%;
        background-color: var(--text-secondary);
        color: #fff;
    }
    .ProgramItem.overtime .status .resolved-icn {
        background-color: #f5d48b;
    }
    .ProgramItem.resolved .status .resolved-icn {
        background-color: #2ecc8a;
    }
    .ProgramItem .meta {
        float: left;
        width: calc(50% - 50px);
    }
    .ProgramItem :global(.block) {
        padding: 5px 0;
        /* width: calc(100% - 50px);
        float: left; */
    }
    .ProgramItem .ops {
        float: right;
        width: 50%;
        padding-left: 6px;
        text-align: left;
    }


    .ProgramItem .lbl {
        font-weight: 600;
    }
    .ProgramItem .txt {
        font-size: 12px;
        color: var(--text-secondary);
        line-height: 14px;
    }
    .ProgramItem .time {
        display: inline-block;
        font-weight: 600;
        margin-right: 5px;
    }

    .dialog-meta {
        margin-top: 10px;
    }
    .dialog-meta .lbl {
        font-weight: 600;
    }
    .dialog-meta .txt {
        font-size: 12px;
        color: var(--text-secondary);
        line-height: 14px;
    }
</style>


<div class="ProgramItem clearfix" 
    class:resolved={data.resolved} 
    class:overtime={data.type === 1} 
    class:otherowner={data.creator !== currentUserId && (data.editedby === null || data.editedby !== currentUserId)}>
    <ListItem classes="block clearfix" actions on:click={editItem}>
        <div class="status">
            <div class="resolved-icn"></div>
        </div>
        <div class="meta">
            <div class="lbl">{data.client.name}</div>
            <div class="txt">
                <span class="time">{moment(data.date).format('HH:mm')}</span>
                {data.description}
            </div>
        </div>
        <div class="ops">
            {#each data.operators as id (id)}
                {#if users[id]}
                    <TagItem 
                        text={users[id].name} 
                        classes={data.operators_done.indexOf (id) !== -1 ? 'completed' : ''} />
                {/if}
            {/each}
        </div>
        
        <div slot="actions">
            <ActionButton icon="far fa-envelope" busy={notifyBusy} disabled={notifyBusy} visited={data.notified} on:click={sendNotification} />
            <ActionButton icon="far fa-user" on:click={openClient} />
            <ActionButton icon="far fa-clone" on:click={cloneItem} />
            <ActionButton icon="far fa-pencil" on:click={editItem} />
            <ActionButton icon="far fa-trash" on:click={deleteItem} />
        </div>
    </ListItem>
</div>


{#if deleteDialog}
    <Dialog 
        title="Vuoi davvero eliminare questo programma?" 
        on:cancel={cancelDelete} 
        on:confirm={confirmDelete}
        leftAlign>
        <div class="dialog-meta">
            <div class="lbl">{data.client.name}</div>
            <div class="txt">{moment (data.date).format ('DD MMM YYYY HH:mm')}</div>
            <div class="txt">{data.description}</div>
        </div>
    </Dialog>
{/if}